// front-end/multimodal/src/App.tsx
import { useState, useEffect } from 'react';
import StoryPlayer from './StoryPlayer.tsx';
import StoryListing from './StoryListing';
import { MyContextProvider } from "./Context";
import './App.css';

const App: React.FC = () => {
  const langParam = new URLSearchParams(window.location.search).get('lang');
  const storyParam = new URLSearchParams(window.location.search).get('story');
  const BASE_URL = "https://cdn.spinningowl.com"
  const LANGUAGE_URL = BASE_URL + (langParam ? "/lang/" + langParam : "/lang/th");
  const STORIES_URL = `${LANGUAGE_URL}/stories`;

  const [selectedStory, setSelectedStory] = useState<string | null>(null);
  const [previousStory, setPreviousStory] = useState<string | null>(null);

  const handleStorySelection = (path: string) => {
    setSelectedStory(path);
  }

  const handleStoryClose = () => {
    setPreviousStory(selectedStory);
    setSelectedStory(null);
  }

  useEffect(() => {
    if (storyParam) {
      setSelectedStory(storyParam);
    }
  }, [storyParam]);
  
  return (
    <MyContextProvider>
      <div className="app">
        {selectedStory ? (
          <StoryPlayer 
            uri={`${STORIES_URL}/${selectedStory}/story.json`} 
            onClose={handleStoryClose} 
            languageUrl={LANGUAGE_URL}
          />
        ) : (
          <StoryListing 
            focusStory={previousStory} 
            listingUri={`${STORIES_URL}/stories_listing.json?t=${Date.now()}`} 
            onStorySelection={handleStorySelection} 
          />
        )}
      </div>
    </MyContextProvider>
  );
};

export default App;